import createReducer from 'Rentlio/state/utils/createReducer'

const initialState = {}

/** used only on offers screen **/
const booking = createReducer(initialState)({})

export default booking
